import { createRouteRef } from '@backstage/core-plugin-api';

/**
 * Root route of the "Learn" page, which lists every onboarding theme as a
 * card.
 */
export const rootRouteRef = createRouteRef({
  id: 'platt-onboarding/learn',
});
